<template>
  <div class="quoteList">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      swipeable
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList(page + 1)"
        >
          <div class="list-container" v-for="(item, index) in tableData" :key="index">
            <template v-if="menuState == 2">
              <div class="list-item">
                {{ $t.salesManagement.qrNumber }}：{{ item.QuotationRefNumber }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.qNumber }}：{{ item.QuotationNumber }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.quoteDate }}：{{ item.CreateTime }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.quotePeople }}：{{ item.UserName }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.companyName }}：{{ item.CompanyName }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.businessType }}：{{ item.BusinessTypeStr }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.delivery }}：{{ item.DeliveryCountryCity }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.destination }}：{{ item.DestinationCountryCity }}
              </div>
            </template>
            <template v-else>
              <div class="list-item">
                {{ $t.salesManagement.qrNumber }}：{{ item.QuotationRefNumber }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.companyName }}：{{ item.CompanyName }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.supplierName }}：{{ item.CustomerName }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.businessType }}：{{ item.BusinessTypeStr }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.delivery }}：{{ item.DeliveryCountryCity }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.destination }}：{{ item.DestinationCountryCity }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.state }}：{{ item.QuotationStateStr }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.nickName }}：{{ item.PhoneNumber }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.sales }}：{{ item.UserName }}
              </div>
              <div class="list-item">
                {{ $t.salesManagement.createTime }}：{{ item.CreateTime }}
              </div>
            </template>
            <div class="buttons">
              <van-button
                class="primary-btn"
                size="small"
                type="primary"
                @click="handleClick(item)"
                >{{ $t.meta.editButton }}</van-button
              >
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div class="radio-label">{{ $t.meta.businessType }}</div>
        <van-radio-group v-model="wbType" direction="horizontal">
          <van-radio name="1">{{ $t.meta.wbType1 }}</van-radio>
          <van-radio name="2">{{ $t.meta.wbType2 }}</van-radio>
          <van-radio name="3">{{ $t.meta.wbType3 }}</van-radio>
          <van-radio name="4">{{ $t.meta.wbType4 }}</van-radio>
          <van-radio name="5">{{ $t.meta.wbType5 }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.salesManagement.state }}</div>
        <van-radio-group v-model="quotationState" direction="horizontal">
          <van-radio :name="1">{{ $t.salesManagement.option1 }}</van-radio>
          <van-radio :name="0">{{ $t.salesManagement.option2 }}</van-radio>
        </van-radio-group>

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoCreate(null)">{{
        $t.salesManagement.addQuote
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  Picker,
  DatetimePicker,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(Picker)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup)
  .use(Tab)
  .use(Tabs);

export default {
  name: "quoteList",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [
        {
          title: this.$t.salesManagement.tab1,
          name: 1,
          count: 0,
        },
        {
          title: this.$t.salesManagement.tab2,
          name: 2,
          count: 0,
        },
      ],
      page: 0,
      pageSize: 10,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.salesManagement.qrNumber,
          value: 1,
        },
        {
          text: this.$t.salesManagement.companyName,
          value: 2,
        },
      ],
      wbType: 0,
      quotationState: null,
      showFilter: false,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList(1);
    },
  },
  created() {
    this.defaultDate();
    if (this.menuState == 1) {
      this.quotationState = 0;
    } else {
      this.quotationState = null;
    }
  },
  methods: {
    defaultDate() {
      let date = new Date();
      let year = date.getFullYear().toString();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString();
      let da =
        date.getDate() < 10 ? "0" + date.getDate().toString() : date.getDate().toString();
      let end = year + "-" + month + "-" + da;
      let beg = year + "-" + month + "-01";
      this.beginTime = beg;
      this.endTime = end;
    },
    handleClick(item) {
      if (this.menuState == 2) {
        this.gotoCreate(item);
      } else {
        this.gotoDetail(item.QRId);
      }
    },
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "quoteDetail",
        name: "quoteDetail",
        query: [
          {
            name: "QRId",
            value: id,
          },
        ],
      });
    },
    gotoCreate(item) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "quoteCreate",
        name: "quoteCreate",
        query: [
          {
            name: "QRId",
            value: item ? item.QRId : "",
          },
          {
            name: "QuotationRefNumber",
            value: "",
          },
          {
            name: "Type",
            value: item ? "detail" : "new",
          },
        ],
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (this.wbType) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.wbType = null;
      this.quotationState = null;
      this.beginTime = "";
      this.endTime = "";
      this.defaultDate();
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
      this.searchText = "";
      this.searchType = 1;
      if (state == 1) {
        this.quotationState = 0;
      } else {
        this.quotationState = null;
      }
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        BusinessType: this.wbType,
        QuotationState: this.quotationState,
        QuotationRefNumber: this.searchType == 1 ? this.searchText : "",
        CompanyName: this.searchType == 2 ? this.searchText : "",
        BeginTime: this.beginTime,
        EndTime: this.endTime,
        CompanyId: this.CompanyId,
        UserId: this.UserId,
      };
      var request = null;
      if (this.menuState == 2) {
        request = this.$api.salesManagement.getQuotationChargesList(param);
      } else {
        request = this.$api.salesManagement.getUnquoteList(param);
      }
      request
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";

.quoteList {
  .searchTop {
    width: 100%;
    background-color: #ffffff;

    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;

      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;

        .van-search__content {
          padding: 0px;
          margin-right: 10px;

          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }

        .custom-date {
          padding: 10px;

          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }

          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }

          .van-button {
            vertical-align: middle;
          }
        }
      }

      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;

        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }

  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);

      .list-item {
        margin-bottom: 10px;
      }

      .list-item:last-child {
        margin-bottom: 0px;
      }

      .buttons {
        text-align: right;

        .primary-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;

          .van-button__text {
            font-size: 14px !important;
          }
        }

        .default-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;

          .van-button__text {
            font-size: 14px !important;
          }
        }

        .search-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;

          .van-button__text {
            font-size: 14px !important;
          }
        }

        .danger-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;

          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }

  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }

  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }

  .van-radio-group {
    margin-bottom: 20px;
  }

  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;

    ::v-deep .van-radio__label {
      color: #646566;
    }
  }

  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;

    .van-cell:after {
      border: none;
    }

    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }

    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;

      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }

      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;

        .van-button__text {
          font-size: 14px !important;
        }
      }

      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;

        .van-button__text {
          font-size: 14px !important;
        }
      }

      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }

  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;

    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }

    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }

  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);

    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
